/*
 * gdlClickEvents
 *
 * GDL Requirements
 * - analytics must receive click events for the below elements
 */

const gdlClickEvents = () => {
  let { triggerGdlEvent } = window;
  const { gdl } = window;

  if (typeof triggerGdlEvent !== 'function') {
    triggerGdlEvent = () => {};
  }

  $('a').on('click', function triggerGdlLinkEvent(event) {
    triggerGdlEvent($(this), 'link', event, '');
  });
  $('input').on('click, focus', function triggerGdlInputEvent(event) {
    triggerGdlEvent($(this), 'input', event, '');
  });
  $('button').on('click', function triggerGdlButtonEvent(event) {
    triggerGdlEvent($(this), 'button', event, '');
  });

  $('.js-trigger-custom-event').on('click', function triggerGdlCustomEvent() {
    const element = $(this);
    const label = element.data('customevent-label');
    if (window.currentGdlEvnt) {
      gdl('event', {
        type: 'button',
        type_event: 'click',
        data: {
          label: `button/${label}`,
        },
      });
    }
  });

  $('.js-trigger-custom-link-event').on('click', function triggerGdlCustomLinkEvent() {
    const element = $(this);
    const label = element.data('customevent-label');
    if (window.currentGdlEvnt) {
      gdl('event', {
        type: 'custom-event',
        type_event: 'click',
        data: {
          label: `link/${label}`,
        },
      });
    }
  });
};

export default gdlClickEvents;
